import React, { Fragment, useState, useEffect, useRef } from "react";
import axios from "axios";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { useTranslation } from 'react-i18next';
import travelimg from '../tr.png';
import { format } from 'date-fns';
import { Container, Form, Row, Col, Card, Button, CardBody } from "react-bootstrap";
import Cookies from 'js-cookie';
import SignatureCanvas from 'react-signature-canvas';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import "./hoteldetails.css";
import hotelimg from "../imagepreview.png"
import { Link } from "react-router-dom";
import { Range } from "react-range";


const { config } = require('../api/api');

  

function ShowHotelDetails({min=0,max=1000,steps=1000}) {


    const base_url = config.baseURL;
    const redirect_url = config.redirectURL;
    const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
    const [loading, setLoading] = useState(true);
    // const base_url="https://stg-api.superjetom.com"
   

    const { t } = useTranslation();

    const [vendorKey, setVendorkey] = useState('');
    
    const [selectedStars, setSelectedStars] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
const [photoIndex, setPhotoIndex] = useState(0);
const [currentHotelId, setCurrentHotelId] = useState(null);
    const [activeHotelId, setActiveHotelId] = useState(null);
    const[hotelnamesearch,setHotelnamesearch] = useState('');
  
    const [showFilters, setShowFilters] = useState(false);
    const [searchDetails,setSearchDetails]=useState(null);
    const [hotelId, setHotelId] = useState(null);
  
 
    const[hoteladdress,setHoteladdress]=useState('');
    const [hotelStarCount,setHotelStarCount]=useState({zero:0,one:0,two:0,three:0,four:0,five:0});
  
 
    const [showUploadModal, setShowUploadModal] = useState(false);
    
    const [barvalue, setBarValue] = useState({minimum:10,maximum:1000});
    const [etmToken, setEtmToken] = useState(null);
  
    const [requestId,setRequestId]=useState(null);

    const [triggerFunction,setTriggerFunction]=useState(false);

      const [range, setRange] = useState([10, 1000]);


    const [hotelDetails,setHotelDetails]=useState([]);
    const [hotelimage,setHotelImage]=useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const hotelsPerPage = 25;
    
    const pattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+)(:[0-9]{1,5})?(\/.*)?$/;

    // useEffect(() => {
    //     const urlSearchString = window.location.search;
    //     const uparams = new URLSearchParams(urlSearchString);
    //     const policy_no = uparams.get('order_id');
    //     setPolicyNo(policy_no);
    // }, []);

    useEffect(() => {
        if (showUploadModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [showUploadModal]);


      useEffect(() => {
        const createOrganization = async () => {
          try {
            const postvData = { organization_name: "Superjet" };

            const response = await fetch( base_url + '/create_organization', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(postvData),
            });
            const data = await response.json();
            setVendorkey(data.result[0].vendor_key);
          } catch (error) {
            console.error('Error posting data:', error);
          }
        };

        if (!vendorKey) {
          createOrganization();
        }
      }, [vendorKey, base_url]);


    const filtervalues = [
        { name: "Free Wi-fi" }, { name: "Parking" }, { name: "Pool" }, { name: "Beach" }, { name: "Restaurant" }, { name: "Fitness Center" }, { name: "Wellness \ SPA" }, { name: "Pets allowed" }, { name: "Child care" }, { name: "Smoke-free property" }

    ]

    const types = [
        { name: " Hotel" }, { name: "Guest house" }, { name: "Apartments" }, { name: " Bed &Breakfast" }, { name: " Villa" }



    ]

    const mealstypes = [
        { name: "Breakfast" }, { name: "No meals included" }, { name: "ApartmentsHalf board" }, { name: " Bed &Breakfast" }, { name: "Full board" }

    ]

    const handleChange = (e) => {
        const {min,max}= e.target
        
        // setBarValue({minimum:Number(min),maximum:Number});
    };

    const StarRating = ({ rating, totalStars = 5 }) => {

        if(rating){
          
        const filledStars = Math.round(rating);
        const emptyStars = totalStars - filledStars;
        const filledArr=new Array(filledStars);
        filledArr.fill("fullStar");
        const emptyArr=new Array(emptyStars);
        emptyArr.fill("fullStar");
        return (
            <div className="star-rating" style={{ display: 'flex', padding: '0' }}>
                {filledArr.map((_, index) => (
                    <span
                        key={`filled-${index}`}
                        //   onClick={() => handleStarClick(index)}
                        style={{ color: 'gold', cursor: 'pointer' }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                            <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                        </svg>
                    </span>
                ))}
                {emptyArr.map((_, index) => (
                    <span
                        key={`empty-${index}`}
                        //   onClick={() => handleStarClick(filledStars + index)}
                        style={{ color: 'gray', cursor: 'pointer' }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star" viewBox="0 0 16 16">
                            <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z" />
                        </svg>
                    </span>
                ))}
            </div>
        );
    }

    else{
      return(
             <div className="star-rating" style={{ display: 'flex', padding: '0' }}>
               
                {Array(5).fill("emptyStar").map((_, index) => (
                    <span
                        key={`empty-${index}`}
                        //   onClick={() => handleStarClick(filledStars + index)}
                        style={{ color: 'gray', cursor: 'pointer' }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star" viewBox="0 0 16 16">
                            <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z" />
                        </svg>
                    </span>
                ))}
            </div>
      )
    }
    } 

    useEffect(() => {
        if (showUploadModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [showUploadModal]);


    const isValidUrl = (url) => {
        return pattern.test(url);
    };


    
    useEffect(() => {
        const storedData = sessionStorage.getItem("ETM_Data");
        if (storedData) {
            const parsedData = JSON.parse(storedData);
            setHotelId(parsedData.hotel_id);
        }
         
    }, []);

      

        useEffect(() => {
            const fetchHotels = async () => {
              try {
                const storedData = Cookies.get("auth_key");
        
                if (storedData) {
                  const storedToken = JSON.parse(storedData);
                  setEtmToken(storedToken);
        
                  // Ensure `data.result.etm_auth_key` is defined before using it
                  if (storedToken) {
                    await searchHotels(vendorKey,storedToken );
                  }
                }
              } catch (error) {
                console.error("Error fetching hotels:", error);
              }
            };
            if(vendorKey!==""&& vendorKey!==null && vendorKey!==undefined){
                fetchHotels();
            }
          }, [vendorKey]);
        
   
        const getRequestId= async (vendor_key,etm_token)=>{
         
            if (vendor_key && etm_token) {
                const searchData=sessionStorage.getItem("hotelSearchData");
             
                setSearchDetails(searchData?JSON.parse(searchData):null);
                const parseDetails=searchData?JSON.parse(searchData):null;
                const parse_rooms=parseDetails.searchdata.rooms?JSON.parse(parseDetails.searchdata.rooms):"";
                parseDetails.searchdata.rooms=parse_rooms;
                if (!parseDetails) {
                    console.error("No search data found in sessionStorage!");
                    return;
                }
              
                        try {
                        const response =await fetch(base_url + "/hotel_search", {
                          method: "POST",
                          headers: {
                            "Authorization": "Bearer " + vendorKey,
                            "Content-Type": "application/json"
                          },
                          body: JSON.stringify(parseDetails)
                        });
                        if (!response.ok) {
                          console.log("http response status : ", response.status)
                        }
                        else {
                          const data = await  response.json();
                          if(data.message==="success"){
                          setRequestId(data.result.request_id);
                          return data.result.request_id;
                          }
                        }
                      }
                      catch (err) {
                        console.log("Hotel Search API Err : ", err);
                      
                      }
                    
                    }
        }

    

        useEffect(()=>{
            if(triggerFunction){
             const starCount = {zero:0, one: 0, two: 0, three: 0, four: 0, five: 0 };
        hotelDetails.forEach(hotel => {
        switch (hotel.stars) {
            case 0: starCount.zero++; break;
            case 1: starCount.one++; break;
            case 2: starCount.two++; break;
            case 3: starCount.three++; break;
            case 4: starCount.four++; break;
            case 5: starCount.five++; break;
            default: break;
          }
        });
    
        setHotelStarCount(starCount);

        let min=0;
        let max=0;
        hotelDetails.forEach((hotel,index)=>{
            if(index==0){
            min=hotel.price_from;
            }

            if(min>hotel.price_from){
                min=hotel.price_from;
            }
            if(max<hotel.price_from){
                max=hotel.price_from;
            }
        })
        debugger
        setBarValue({minimum:Math.round(min)-1,maximum:Math.round(max)+1})
        setRange([Math.round(min)-1,Math.round(max)+1])



        setTriggerFunction(false);

setTimeout(()=>{
 setLoading(false);
},1000);
       
    }
        },[triggerFunction])


const searchHotels = async (vendor_key,etm_token)=>{

    try{
      
     const request_id=await getRequestId(vendor_key,etm_token);
    //  const request_id="a8ccc799-514d-4810-ae97-cf709a2886ca";
    
     if(request_id){
    setTimeout(async()=>{
        await getHotelDetails(vendor_key,etm_token,request_id);
    },4000);
    
     }
    }
    catch(err){
        console.log(err);
    }
}



const getHotelDetails= async (vendor_key,etm_token,request_id)=>{
    var count =6;
    let last_variant_id = null;
    var id=0;
    
    for(let i=0;i<=count;i++)
        {
    try {
        
        var findHotelreq={
            etmtoken:etm_token,  
            request_id: request_id, 
            searchdata:{
            currency:"USD",
            last_variant_id: last_variant_id===null || last_variant_id===0  ? null: String(last_variant_id),
            limit:1000
        }
        }
        const response =await fetch(base_url+ "/found_hotel", {
          method: "POST",
          headers: {
            "Authorization": "Bearer " + vendor_key,
            "Content-Type": "application/json"
          },
          body: JSON.stringify(findHotelreq)
        });
        if (!response.ok) {
          console.log("http response status : ", response.status)
        }
        else {
          const data = await  response.json();
          if(data.message==="success"){
        //    const hotel=data.result.data.hotels
        const  hotelArr=[...hotelDetails];
        // let n=hotelArr.length;
      
        if(data.result.data.hotels.length>0){
          for(let i=0;i<data.result.data.hotels.length;i++){
                  const hotelIds = hotelArr.map(hotel => hotel.id);
                  if(!hotelIds.includes(data.result.data.hotels[i].id)){
          hotelArr.push(data.result.data.hotels[i]);
                  }
        }
            // const hotelsArray = data.result.data.hotels;
           setHotelDetails(hotelArr);
   
        }
        last_variant_id = data.result.data.last_variant_id

       

      if ( id > 6) {
           
            console.log("Hotels found! Ending loop.");
            return;
        }
      if(last_variant_id===null){
        id+=1;
      }
          } 
        }
      }
      catch (err) {
        console.log("Hotel Search API Err : ", err);
        setLoading(false);
      }
      finally{
       setTriggerFunction(true);
      }

     
      }
  
}

const hotelsearch=(e)=>{
setHotelnamesearch(e.target.value)
}

const hoteladdressforfilter=(e)=>{
    setHoteladdress(e.target.value)
}

const clearfiter=()=>{
    setHoteladdress('');
    setHotelnamesearch('');
    setRange([barvalue.minimum,barvalue.maximum]);
    setSelectedStars([]);
}

 const hotelImage=async(hotel_id)=>{
        
        try{
                const storedData = Cookies.get("auth_key");
        
                if (storedData) {
                  const storedToken = JSON.parse(storedData);
                  setEtmToken(storedToken);
                }
            var findImg={
                etmtoken:etmToken,  
                hotel_id:hotel_id             
        }
        
        const response =await fetch(base_url+ "/get_hotel_info", {
            method: "POST",
            headers: {
              "Authorization": "Bearer " + vendorKey,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(findImg)
          });
          if (!response.ok) {
            console.log("http response status : ", response.status)
          }
          else{
         
            const data = await  response.json();
            if(data.message==="success" && data.result && data.result.images){
                
                setHotelImage((prev) => ({
                    ...prev,
                    [hotel_id]: data.result.images
                  }));
                   setCurrentHotelId(hotel_id); // for lightbox
        setPhotoIndex(0);            // start with first image
        setIsOpen(true); 

            }
        }
            }
              catch (error) {
                console.error("Error fetching hotel images:", error);
              }
    }


const handleStarFilterChange = (star) => {
  setSelectedStars(prev => 
    prev.includes(star)
      ? prev.filter(s => s !== star)  // remove if already selected
      : [...prev, star]               // add if not selected
  );
};


    const showHotelOffer =(e,hotel_id,hotel_img)=>{
        e.preventDefault();
        const setData={
            etmtoken:etmToken,
            hotel_id:hotel_id,
            hotel_img:hotel_img
        }
        sessionStorage.setItem("ETM_Data",JSON.stringify(setData));
        window.location.href="/hotel-rooms"
    }


    const handleHotelFiltersButton=(element,actionsName)=>{
    
        debugger
        const ele =element.currentTarget.classList;
        const remove_active =["ascending","descending","rating"];
         if(actionsName==="ascending"){
            
             remove_active.forEach((obj)=>{
                document.getElementById(obj).classList.remove('active');
             });
             ele.add("active");


             // ascending
 const sorted = [...hotelDetails].sort((a, b) => {
       return a.price_from - b.price_from;
    });
    setHotelDetails(sorted);


         }
         else if(actionsName ==="descending"){
             remove_active.forEach((obj)=>{
                document.getElementById(obj).classList.remove('active');
             });
              ele.add("active");

              //descending
              const sorted = [...hotelDetails].sort((a, b) => {
       return   b.price_from-a.price_from;
    });
    setHotelDetails(sorted);

         }
         else if(actionsName==="rating"){
             remove_active.forEach((obj)=>{
                document.getElementById(obj).classList.remove('active');
             });
              ele.add("active");

              //rating star based 

const starDescending = [...hotelDetails].sort((a, b) => b.stars - a.stars);

            setHotelDetails(starDescending)
         }
    }
   

     const handleMinChange = (e) => {
    const newMin = Math.min(Number(e.target.value), range.max - 1);
    setRange({ ...range, min: Math.round(newMin) });
  };

  const handleMaxChange = (e) => {
    debugger
    const newMax = Math.max(Number(e.target.value), range.min + 1);
    setRange({ ...range, max: Math.round(newMax) });
  };

  const minPercent = ((range[0] - barvalue.minimum) / (barvalue.maximum - barvalue.minimum)) * 100;
const maxPercent = ((range[1] - barvalue.minimum) / (barvalue.maximum - barvalue.minimum)) * 100;

// Pagination logic
const filteredHotels = hotelDetails?.filter(hotel => 
    (selectedStars?.length === 0 || selectedStars?.includes(hotel.stars)) && 
    hotel.price_from>=range[0] && 
    hotel.price_from <= range[1] && 
    hotel.name.toLowerCase().includes(hotelnamesearch.toLowerCase()) && 
    hotel.address.toLowerCase().includes(hoteladdress.toLowerCase())
);

const totalPages = Math.ceil(filteredHotels?.length / hotelsPerPage);
const startIndex = (currentPage - 1) * hotelsPerPage;
const currentHotels = filteredHotels?.slice(startIndex, startIndex + hotelsPerPage);

const handlePrevPage = () => {
    if (currentPage > 1) {
        setCurrentPage(currentPage - 1);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
};

const handleNextPage = () => {
    if (currentPage < totalPages) {
        setCurrentPage(currentPage + 1);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
};


  

    return (

        <Fragment>

            <div className="header_section1">

                <Navbar />


                <div className="container-fluid bg-breadcrumb">
                    <div className="container text-center py-5">
                        <h3 className="abt-txt my-5">{(lnstr === 'en') ? 'e-Hotel Details' : 'تفاصيل الفندق الإلكتروني\n'}</h3>
                    </div>
                </div>


            </div>


            <div className="features_section">
                <div className="container">

                    <div className="row" style={{justifyContent:"center"}}>
                      {
                        hotelDetails.length>0 && <Col md={4} className="myforms my-2 my-md-5 " >


                       

                            {/* Desktop Filters */}
                            <div className="d-none d-md-block">


                            <div className="pt-4">
                                <div className="card container shadow">
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <h1 className="pt-3"><strong>{t("Filter")}</strong></h1>
                                        </div>
                                        {/* <div className="pt-3">
                                            <button className="btn btn-primary" type="submit">Map</button>
                                        </div> */}
                                    </div>
                                    <div className="card-body">
                                        <div>
                                            <h6><strong><u>{t("Search hotel by name")}</u></strong></h6>
                                        </div>
                                        <div>
                                            <input type='text' className="form-control" placeholder={t("Hotel")} value={hotelnamesearch} onChange={hotelsearch} />
                                        </div>
                                        {/* <hr /> */}

                                        {/* <div className="pt-2">
                                            <h6><strong><u>{t("Policy")}</u></strong></h6>
                                        </div> */}
                                        <div>
                                            {/* <div className=" form-switch d-flex justify-content-start">
                                                <input className="" type="checkbox" id="flexSwitchCheckDefault" />
                                                <label className="mx-2" style={{position:"relative",top:"3px"}} for="flexSwitchCheckDefault">
                                                    {t("Free cancellation")}</label>
                                            </div> */}
                                        </div>
                                        <hr />

                                        <div className="pt-2">
                                            <h6><strong><u>{t("Hotel class")}</u></strong></h6>

                                        </div>
                                        <div>
                                            <div className="form-switch d-flex justify-content-between">
                                            <div>

                                                <input className="" type="checkbox"  id="star5" checked={selectedStars.includes(5)} onChange={() => handleStarFilterChange(5)}/>
                                             
                                                <label className="mx-2" for="flexSwitchCheckDefault"  htmlFor="star1">
                                                   {/* {[...Array(4)].map((_, i) => ( */}
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                                                    </svg> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                                                    </svg><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                                                    </svg><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                                                    </svg><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                                                    </svg>
                                                    
                                                    </label>
                                                       </div>
                                                    <div>
                                                    ({hotelStarCount?.five})
                                                    </div>
                                            </div>



                                            <div className=" form-switch d-flex justify-content-between">
                                            <div>
                                                <input className="" type="checkbox" id="star4" checked={selectedStars.includes(4)} onChange={() => handleStarFilterChange(4)} />
                                                <label className="mx-2" for="flexSwitchCheckDefault">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                                                    </svg> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                                                    </svg><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                                                    </svg><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                                                    </svg></label>
                                                     </div>
                                                    <div>
                                                    ({hotelStarCount?.four})
                                                    </div>
                                            </div>



                                            <div className=" form-switch d-flex justify-content-between">
                                            <div>
                                                <input className="" type="checkbox" id="star3" checked={selectedStars.includes(3)} onChange={() => handleStarFilterChange(3)}  />
                                                <label className="mx-2" for="flexSwitchCheckDefault">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                                                    </svg> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                                                    </svg><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                                                    </svg></label>
                                                    </div>
                                                    <div>
                                                    ({hotelStarCount?.three})
                                                    </div>
                                            </div>




                                            <div className=" form-switch d-flex justify-content-between ">
                                            <div>
                                                <input className="" type="checkbox" id="star2" checked={selectedStars.includes(2)} onChange={() => handleStarFilterChange(2)}  />
                                                <label className="mx-2" for="flexSwitchCheckDefault">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                                                    </svg> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                                                    </svg></label>
                                                    </div>
                                              <div>({hotelStarCount?.two})</div>
                                            </div>


                                            <div className=" form-switch d-flex justify-content-between">
                                               <div>
                                                <input className="" type="checkbox" id="star1" checked={selectedStars.includes(1)} onChange={() => handleStarFilterChange(1)}  />
                                                <label className="mx-2" for="flexSwitchCheckDefault">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                                                    </svg> </label>
                                                    </div>
                                                      <div>({hotelStarCount?.one})</div>
                                            </div>
                                            <br />

                                            <div className=" form-switch d-flex justify-content-between">
                                              <div>
                                                <input className="" type="checkbox"  id="flexSwitchCheckDefault"  checked={selectedStars.includes(0)} onChange={() => handleStarFilterChange(0)} />
                                                <label className="mx-2" for="flexSwitchCheckDefault">{t("Show hotels without stars")}</label>
                                            </div>
                                            <div>({hotelStarCount?.zero})</div>
</div>
                                        </div>
                                        <hr />

                                       <div dir="ltr">
                                        <div className="pt-2">
                                            <h6 className="my-3"><strong><u>{t("Price")}</u></strong></h6>
                                        </div>
                                        {/* <div className="d-flex" style={{ width: "100%" }}>
      <input
        type="range"
        min={barvalue.minimum}
        max={barvalue.maximum/2}
        value={range.min}
        onChange={handleMinChange}
        style={{
          width: "100%",
          appearance: "none",
          height: "8px",
          background: "#ddd",
          cursor: "pointer",
          marginBottom: "10px",
        }}
      />
      <input
        type="range"
        min={barvalue.maximum/2+1}
        max={barvalue.maximum}
        value={range.max}
        onChange={handleMaxChange}
        style={{
          width: "100%",
          appearance: "none",
          height: "8px",
          background: "#ddd",
          cursor: "pointer",
          marginBottom: "10px",
        }}
      />
     
    </div> */}

 <Range
  step={0.1}
  min={barvalue.minimum}
  max={barvalue.maximum}
  values={range}
  onChange={(values) => setRange([Math.floor(values[0]),Math.floor(values[1])])}
  renderTrack={({ props, children }) => (
    <div
      onMouseDown={props.onMouseDown}
      onTouchStart={props.onTouchStart}
      ref={props.ref}
      style={{
        ...props.style,
        height: "8px",
        width: "100%",
        borderRadius: "4px",
        background: `linear-gradient(to right, 
  #ccc 0%, 
  #ccc ${minPercent}%, 
  #007bff ${minPercent}%, 
  #007bff ${maxPercent}%, 
  #ccc ${maxPercent}%, 
  #ccc 100%)`,
  display: "flex",
        alignItems: "center",
        boxShadow: "inset 0 1px 2px rgba(0,0,0,0.1)",
        transition: "background 0.3s ease-in-out",
      }}
    >
      {children}
    </div>
  )}
  renderThumb={({ props, isDragged }) => (
    <div
      {...props}
      style={{
        ...props.style,
        height: "20px",
        width: "20px",
        borderRadius: "50%",
        backgroundColor: isDragged ? "#0056b3" : "#007bff",
        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
        border: "2px solid white",
        cursor: "pointer",
        transition: "background-color 0.2s ease",
        top:"1px"
      }}
    />
  )}
/>


     <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "10px",
        }}
      >
        <div>{t("Min")}: ${range[0]}</div>
        <div>{t("Max")}: ${range[1]}</div>
      </div>
      </div>

                                        {/* <div className="pt-2">
                                            <h6><strong><u>Search hotel by facilities</u></strong></h6>
                                        </div>
                                        <div>
                                            {filtervalues.map((val, index) =>
                                                <div className="form-check form-switch">
                                                    <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" />
                                                    <label className="form-check-label" for="flexSwitchCheckDefault">
                                                        {val.name}</label>
                                                </div>

                                            )}

                                        </div> */}
                                        {/* <hr /> */}

                                        {/* <div className="pt-2">
                                            <h6><strong><u>Property Type</u></strong></h6>
                                        </div>
                                        <div>
                                            {types.map((type, index) =>
                                                <div className="form-check form-switch">
                                                    <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" />
                                                    <label className="form-check-label" for="flexSwitchCheckDefault">
                                                        {type.name}</label>
                                                </div>

                                            )}

                                        </div> */}
                                        <hr />


                                        {/* <div className="pt-2">
                                            <h6><strong><u>Meal type</u></strong></h6>
                                        </div>
                                        <div>
                                            {mealstypes.map((value, index) =>
                                                <div className="form-check form-switch">
                                                    <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" />
                                                    <label className="form-check-label" for="flexSwitchCheckDefault">
                                                        {value.name}</label>
                                                </div>

                                            )}

                                        </div>
                                        <hr /> */}

                                        {/* <div className="pt-2">
                                            <h6><strong><u>Address</u></strong></h6>
                                        </div>
                                        <div>
                                            <input type="text" className="form-control" placeholder="Address" value={hoteladdress} onChange={hoteladdressforfilter}/>
                                        </div>

                                        <hr /> */}

                                        <div className="pt-2">
                                            <button type="submit" className="btn btn-primary" onClick={clearfiter}>{t("Clear Filter")}</button>
                                        </div>

                                    </div>
                                </div>
                            </div>
</div>
                        

                                      
                            {showFilters && (
                                <div className="position-fixed w-100 h-100 d-md-none" style={{top: 0, left: 0, zIndex: 1050}}>
                                    <div 
                                        className="position-absolute w-100 h-100" 
                                        style={{background: 'rgba(0,0,0,0.5)'}}
                                        onClick={() => setShowFilters(false)}
                                    />
                                    <div className="position-absolute w-100 h-100 d-flex align-items-end">
                                        <div className="bg-white w-100 rounded-top-3 shadow-lg" style={{maxHeight: '80vh', overflowY: 'auto'}}>
                                            <div className="p-3 border-bottom d-flex justify-content-between align-items-center sticky-top bg-white">
                                                <h5 className="mb-0 fw-bold">{t("Filter")}</h5>
                                                <button 
                                                    className="btn btn-outline-secondary btn-sm" 
                                                    onClick={() => setShowFilters(false)}
                                                >
                                                    ✕
                                                </button>
                                            </div>
                                            <div className="p-3">
                                                <div className="mb-3">
                                                    <h6 className="fw-bold text-decoration-underline">{t("Search hotel by name")}</h6>
                                                    <input type='text' className="form-control" placeholder={t("Hotel")} value={hotelnamesearch} onChange={hotelsearch} />
                                                </div>
                                                <hr />
                                                <div className="mb-3">
                                                    <h6 className="fw-bold text-decoration-underline">{t("Hotel class")}</h6>
                                                    {[5,4,3,2,1].map(stars => (
                                                        <div key={stars} className="d-flex justify-content-between align-items-center mb-2">
                                                            <div>
                                                                <input type="checkbox" id={`mobile-star${stars}`} checked={selectedStars.includes(stars)} onChange={() => handleStarFilterChange(stars)}/>
                                                                <label className="ms-2" htmlFor={`mobile-star${stars}`}>
                                                                    {[...Array(stars)].map((_, i) => (
                                                                        <svg key={i} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-star-fill" viewBox="0 0 16 16">
                                                                            <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                                                                        </svg>
                                                                    ))}
                                                                </label>
                                                            </div>
                                                            <span>({hotelStarCount?.[stars === 5 ? 'five' : stars === 4 ? 'four' : stars === 3 ? 'three' : stars === 2 ? 'two' : 'one']})</span>
                                                        </div>
                                                    ))}
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <div>
                                                            <input type="checkbox" id="mobile-star0" checked={selectedStars.includes(0)} onChange={() => handleStarFilterChange(0)} />
                                                            <label className="ms-2" htmlFor="mobile-star0">{t("Show hotels without stars")}</label>
                                                        </div>
                                                        <span>({hotelStarCount?.zero})</span>
                                                    </div>
                                                </div>
                                                <hr />
                                                <div className="mb-3">
                                                    <h6 className="fw-bold text-decoration-underline mb-3">{t("Price")}</h6>
                                                    <Range
                                                        step={0.1}
                                                        min={barvalue.minimum}
                                                        max={barvalue.maximum}
                                                        values={range}
                                                        onChange={(values) => setRange([Math.floor(values[0]),Math.floor(values[1])])}
                                                        renderTrack={({ props, children }) => (
                                                            <div
                                                                onMouseDown={props.onMouseDown}
                                                                onTouchStart={props.onTouchStart}
                                                                ref={props.ref}
                                                                style={{
                                                                    ...props.style,
                                                                    height: "8px",
                                                                    width: "100%",
                                                                    borderRadius: "4px",
                                                                    background: `linear-gradient(to right, #ccc 0%, #ccc ${minPercent}%, #007bff ${minPercent}%, #007bff ${maxPercent}%, #ccc ${maxPercent}%, #ccc 100%)`,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                {children}
                                                            </div>
                                                        )}
                                                        renderThumb={({ props, isDragged }) => (
                                                            <div
                                                                {...props}
                                                                style={{
                                                                    ...props.style,
                                                                    height: "20px",
                                                                    width: "20px",
                                                                    borderRadius: "50%",
                                                                    backgroundColor: isDragged ? "#0056b3" : "#007bff",
                                                                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                                                    border: "2px solid white",
                                                                    cursor: "pointer",
                                                                    
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                    <div className="d-flex justify-content-between mt-2">
                                                        <span>{t("Min")}: ${range[0]}</span>
                                                        <span>{t("Max")}: ${range[1]}</span>
                                                    </div>
                                                </div>
                                                <div className="d-flex gap-2 pt-3 border-top">
                                                    <button className="btn btn-outline-secondary flex-fill" onClick={clearfiter}>{t("Clear Filter")}</button>
                                                    <button className="btn btn-primary flex-fill" onClick={() => setShowFilters(false)}>{t("Apply Filters")}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </Col>
                        }



                        <Col md={8} className="myforms my-5" >
                            {/* Mobile Filter Button */}
                            <div className="d-md-none mb-3">
                                <button
                                    className="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2"
                                    onClick={() => setShowFilters(true)}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-sliders" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3h9.05zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8h2.05zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1h9.05z"/>
                                    </svg>
                                    {t("Filter Hotels")}
                                </button>
                            </div>

                            <br />

                            <div>
                              {
                                hotelDetails.length>0 && !loading &&  <div className="card container pt-2 shadow">
                                    <div className="row d-flex justify-content-between">
                                        <div className="p-2">
                                            <p>{t("Available")} {filteredHotels?.length} {t("hotels from")} {hotelDetails?.length}</p>
                                        </div>
                                        <div>
                                            <div className="d-flex justify-content-between">
                                                <div className="p-2">
                                                    <p className="hotel-hori-filters" id="ascending" onClick={(e)=>{handleHotelFiltersButton(e,"ascending")}}>{t("Price ascending")}</p>
                                                </div>
                                                <div className="p-2" >
                                                    <p className="hotel-hori-filters" id="descending"  onClick={(e)=>handleHotelFiltersButton(e,"descending")}>{t("Price descending")} </p>
                                                </div>
                                                <div className="p-2">
                                                    <p className="hotel-hori-filters" id="rating" onClick={(e)=>handleHotelFiltersButton(e,"rating")}>{t("By rating")}</p>
                                                </div>
                                            </div>
                                            <div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                }
                                <br />
                             <>
  {currentHotels?.map((hotel, index) => (
    <div key={index}>
      <div className="card col-sm-12 shadow">
        <div className="row">
          <div className="col-md-3 p-0" style={{ cursor: "pointer", position: 'relative' }}>
            <div onClick={() => hotelImage(hotel.id)}>
              <img
                src={hotel.image_url}
                alt={hotel.name}
                style={{ objectFit: 'cover', width: '200px', height: '100px' }}
                className="hotel-img"
              />
              {/* <div class="hotel-info-image__images-number">
            +85
          </div> */}
              <div
                style={{
                  position: 'absolute',
                  bottom: '5px',
                  left: '5px',
                  backgroundColor: 'rgba(0, 0, 0, 0.6)',
                  color: 'white',
                  padding: '2px 6px',
                  fontSize: '12px',
                  borderRadius: '3px',
                }}
              >
                <span><img src={hotelimg} alt="image_icon" width="13" height="10" style={{ filter: 'invert(1)' }}/></span>
                +{hotel.image_qty}
              </div>

            </div>

            {isOpen && hotelimage[currentHotelId]?.length > 0 && (
              <>
               <Lightbox
                  mainSrc={hotelimage[currentHotelId][photoIndex].url}
                  nextSrc={hotelimage[currentHotelId][(photoIndex + 1) % hotelimage[currentHotelId].length].url}
                  prevSrc={
                    hotelimage[currentHotelId][
                      (photoIndex + hotelimage[currentHotelId].length - 1) % hotelimage[currentHotelId].length
                    ].url
                  }
                  onCloseRequest={() => setIsOpen(false)}
                  onMovePrevRequest={() =>
                    setPhotoIndex(
                      (photoIndex + hotelimage[currentHotelId].length - 1) % hotelimage[currentHotelId].length
                    )
                  }
                  onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % hotelimage[currentHotelId].length)}
                  imageTitle={`${photoIndex + 1} / ${hotelimage[currentHotelId].length}`}
                  wrapperClassName="custom-lightbox"
                />
                <div
                  style={{
                    position: 'fixed',
                    bottom: 10,
                    left: 0,
                    right: 0,
                    padding: '10px 20px',
                    display: 'flex',
                    overflowX: 'auto',
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    zIndex: 2000,
                    gap: '10px',
                  }}
                >
                  {hotelimage[currentHotelId]?.map((img, idx) => (
                    <img
                      key={idx}
                      src={img.url}
                      alt={`Thumb ${idx}`}
                      onClick={() => setPhotoIndex(idx)}
                      style={{
                        width: '80px',
                        height: '60px',
                        objectFit: 'cover',
                        border: idx === photoIndex ? '3px solid #00bfff' : '2px solid #666',
                        opacity: idx === photoIndex ? 1 : 0.6,
                        cursor: 'pointer',
                        borderRadius: '4px',
                        transition: 'all 0.2s ease-in-out',
                      }}
                    />
                  ))}
                </div>
              </>
            )}
          </div>

          <div className="hotel-details col-md-9 d-flex  pt-2 ">
            <div>
              <h4 className="p-0 d-flex justify-content-start">{hotel.name}</h4>
              <StarRating rating={hotel.stars} />
              <p className="d-flex justify-content-start">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-geo-alt-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
                  </svg>
                </span>
                {hotel.address}
              </p>
            </div>
            <div>
              <h4>{t("from")} {hotel?.price_from?.toFixed(2)}&nbsp;$</h4>
              <div className="show-offer-btn d-flex ">
              <button
                type="submit"
                onClick={(e) => showHotelOffer(e, hotel.id, hotel.image_url)}
                className="btn btn-primary"
              >
                {t("Show offer")}
              </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
  ))} 
</>
<>
   {
    (!loading && hotelDetails.length>0) &&
    filteredHotels?.length===0  && <div>
<div className="text-center">
   <i class="fas fa-search" style={{fontSize:"30px"}}></i>
</div>
  <div className="d-flex justify-content-center">
         <h3>{t("No")} {t("hotel")} {t("found.")}</h3>
        </div>
    </div>
   } 
</>

                            </div>
                            
                            {/* Pagination */}
                            <div className="col-12 col-md-11">
                             {totalPages <=1 ? (
  <div></div>
) : (
  <div
    className="d-flex justify-content-center align-items-center  mt-4"
    style={{ userSelect: "none",gap:"20px" }}
  >

  
    {/* PREV BUTTON */}
    <button
      onClick={handlePrevPage}
      disabled={currentPage === 1}
      style={{
        background: "#f1f1f1",
        border: "1px solid #d0d0d0",
        padding: "8px 14px",
        borderRadius: "8px",
        cursor: currentPage === 1 ? "not-allowed" : "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "0.2s",
      }}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path
          d="M15 18L9 12L15 6"
          stroke="#333"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>

    {/* TEXT */}
    <span className="fw-semibold" style={{ fontSize: "16px" }}>
      {t("Page")} {currentPage} {t("of")} {totalPages}
    </span>

    {/* NEXT BUTTON */}
    <button
      onClick={handleNextPage}
      disabled={currentPage === totalPages}
      style={{
        background: "#f1f1f1",
        border: "1px solid #d0d0d0",
        padding: "8px 14px",
        borderRadius: "8px",
        cursor: currentPage === totalPages ? "not-allowed" : "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "0.2s",
      }}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path
          d="M9 18L15 12L9 6"
          stroke="#333"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
    </div>
)}

                            </div>
                            
{hotelDetails.length<=0 && !loading &&  <div>
<div className="text-center">
   <i class="fas fa-search" style={{fontSize:"30px"}}></i>
</div>
<div className="text-center mt-3">
    <h4>{lnstr=="en"? "Nothing found":"لا يوجد نتائج"}</h4> 
<h4>{lnstr=="en"?"Try changing the request parameter":"الرجاء تغيير معلومات البحث"}</h4>
</div>
<div className="text-center mt-3">
<Link to="/hotel-search">
<button className="btn-primary">
  {lnstr=="en"? "Back to Search":"العودة للبحث"}
</button>
</Link>
</div>
</div>}

                        </Col>
                        
                    </div>
                </div>
          </div>
            <Footer />



            {loading && (
                <div className="overlay">
                    <div className="spinner"></div>
                </div>
            )}

        </Fragment>


    );
}

export default ShowHotelDetails;